import { loadStripe as d } from "@stripe/stripe-js/pure";
import { getAdapter as h } from "../../../reactive/features/api/adapter.js";
import { StripeEngineConfigAdapter as m } from "../../../reactive/features/api/models/payment/stripe/stripeEngineConfig/stripeEngineConfig.adapter.js";
import { PaymentAPI as a } from "../paymentApi.js";
import { PaymentProcessAPI as y } from "../paymentProcess.js";
class w extends y.PaymentProcess {
  constructor(t) {
    super({
      ...t,
      engine: a.PaymentMethodEngine.STRIPE,
      engineConfigAdapter: h(m)
    }), this.isCardValid = !1;
  }
  async afterInitialize(t) {
    const e = await d(t.publicKey);
    if (e === null)
      throw new Error("Cannot initialize stripe object");
    this.stripe = e, a.THIRD_PARTY_METHODS.includes(this.configuration.method) && await this.initializeThirdPartyPayment();
  }
  updateEngineAmount(t) {
    var e;
    (e = this.thirdPartyPaymentData) == null || e.paymentRequest.update({
      total: {
        amount: t.amount + t.tip,
        label: this.thirdPartyPaymentData.statementDescriptor
      }
    });
  }
  async mount(t) {
    if (a.THIRD_PARTY_METHODS.includes(this.configuration.method))
      return;
    if (!this.stripe)
      throw new Error("Stripe is not ready yet");
    const e = document.createElement("div");
    e.style.padding = "16px";
    const o = this.stripe.elements();
    this.cardElement = o.create("card", {
      disableLink: !0,
      hidePostalCode: !0
    }), this.cardElement.on("change", (r) => {
      this.isCardValid = !r.error;
    }), t.appendChild(e), this.cardElement.mount(e);
  }
  async initializeThirdPartyPayment() {
    if (!this.stripe)
      throw new Error("Stripe is not ready yet");
    const {
      configuration: {
        countryCode: t,
        statementDescriptor: e
      }
    } = await this.paymentRepository.initProcessPayment({
      channel: this.configuration.channel,
      methodType: this.configuration.method,
      engineType: this.configuration.engine,
      locationId: this.configuration.locationId
    }), o = this.stripe.paymentRequest({
      country: t,
      currency: this.configuration.currency.toLowerCase(),
      total: {
        label: e,
        amount: this.configuration.amount + this.configuration.tip - this.configuration.cashback
      }
    });
    if (!await o.canMakePayment())
      throw new Error("Wallet is not available");
    this.thirdPartyPaymentData = {
      paymentRequest: o,
      statementDescriptor: e
    };
  }
  async executeThirdpartyPayment(t, e) {
    const { paymentRequest: o } = e, r = new Promise((c, n) => {
      o.off("cancel").on("cancel", () => n(
        new Error("Payment has been canceled by user")
      )), o.off("paymentmethod").on("paymentmethod", async (i) => {
        try {
          const s = await this.paymentRepository.confirmProcessPayment({
            paymentMethodId: i.paymentMethod.id,
            locationId: this.configuration.locationId,
            amount: this.configuration.amount,
            cashback: this.configuration.cashback,
            tip: this.configuration.tip,
            userFullName: t.email,
            email: t.email,
            externalUserId: t.externalUserId,
            currency: this.configuration.currency,
            orderId: t.orderId,
            paymentMethods: [{
              engine: this.configuration.engine,
              methodType: this.configuration.method
            }],
            wsUuid: t.wsUuid,
            selectedItems: t.selectedItems,
            shopUrl: t.shopUrl,
            actions: t.actions,
            loyaltyId: t.loyaltyId,
            phoneNumber: t.phone,
            storePaymentMethod: t.storePaymentMethod,
            countryCode: this.configuration.countryCode,
            shopOrderSource: this.configuration.shopOrderSource
          });
          i.complete("success"), c(s);
        } catch {
          i.complete("fail"), n();
        }
      });
    });
    return o.show(), r;
  }
  async executeCardPayment(t) {
    if (!this.stripe || !this.cardElement || !this.isCardValid)
      throw new Error("Payment form is not valid");
    const e = await this.stripe.createPaymentMethod({
      type: "card",
      card: this.cardElement,
      billing_details: {
        name: t.name,
        email: t.email,
        phone: t.phone
      }
    });
    if (e.error)
      throw new Error(e.error.message);
    if (!e.paymentMethod)
      throw new Error("Could not fetch payment method from stripe");
    return {
      ...await this.paymentRepository.process({
        orderId: t.orderId,
        amount: this.configuration.amount,
        shopUrl: t.shopUrl,
        tip: this.configuration.tip,
        cashback: this.configuration.cashback,
        email: t.email,
        externalUserId: t.externalUserId,
        wsUuid: t.wsUuid,
        currency: this.configuration.currency,
        actions: t.actions,
        locationId: this.configuration.locationId,
        paymentMethodId: e.paymentMethod.id,
        selectedItems: t.selectedItems,
        loyaltyId: t.loyaltyId,
        paymentMethods: [{
          engine: this.configuration.engine,
          methodType: this.configuration.method
        }],
        storePaymentMethod: t.storePaymentMethod,
        countryCode: this.configuration.countryCode,
        shopOrderSource: this.configuration.shopOrderSource
      }),
      tokenizedCard: {
        externalId: e.paymentMethod.id
      }
    };
  }
  executePayment(t) {
    return this.thirdPartyPaymentData ? this.executeThirdpartyPayment(t, this.thirdPartyPaymentData) : this.executeCardPayment(t);
  }
  async destroy() {
    var t;
    (t = this.cardElement) == null || t.destroy();
  }
}
export {
  w as StripePaymentProcess
};
//# sourceMappingURL=stripe.process.js.map
